import { type PersonOption } from '../types.ts';

export const mergePopulatedValue = (populatedOptions: PersonOption[], options: PersonOption[]) =>
  options.map(option => {
    const populatedOption = populatedOptions.find(populatedOpt => populatedOpt.id === option.id);

    if (populatedOption) {
      return {
        ...option,
        ...populatedOption,
      };
    }

    return option;
  });
